// src/components/auth/PublicRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../authContext.jsx';
import { LoadingSpinner } from '../../general/LoadingSpinner';
import { logger } from '../../../utils/logger';

export const PublicRoute = ({ restricted = false }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  logger.log('PublicRoute check:', { restricted, isAuthenticated, isLoading });
  
  // Wait for auth to load before making routing decisions
  if (isLoading) {
    return <LoadingSpinner message="Loading..." />;
  }
  
  // If route is restricted and user is logged in, redirect to home
  if (restricted && isAuthenticated) {
    logger.log('Restricted route with authenticated user, redirecting to /home');
    return <Navigate to="/home" replace />;
  }
  
  // Render child routes
  return <Outlet />;
};